var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-info is-small header"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container m-y-xl p-l-md"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }